import {
  Lightbulb,
  PuzzleIcon,
  ShieldCheck,
  UserRoundCheck,
} from "lucide-react";

export const aboutContent = {
  banner: {
    button: {
      text: "Start Your Free Trial",
      url: "/sign-up",
    },
    description: "Redefining the Future with AI ",
    id: "1",
    sectionTile: "",
    title: "Welcome to iNextLabs",
    videoURL:
      "https://inextlabswebassets.blob.core.windows.net/video/_import_614eee66b667f2.55953610.mp4",
  },
  teams: [
    {
      name: "Sachin Hridayraj",
      jobTitle: "CoFounder",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/Sachin-Pic.webp",
    },
    {
      name: "Murugappan",
      jobTitle: "CoFounder, Head of Engineering",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/Muru-Pic.webp",
    },
    {
      name: "Shanmuga Ganesan",
      jobTitle: "Managing Director, Malaysia",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/shan.webp",
    },
    {
      name: "Frank Teh",
      jobTitle: "Advisor, Enterprise Strategy",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/frank.webp",
    },
    {
      name: "Annamalai Meyyappan",
      jobTitle: "Advisor, Finance",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/annamalai.webp",
    },
    {
      name: "S.C. Balaji",
      jobTitle: "Head of BFSI Strategy and Operations",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/scbalaji.webp",
    },
    {
      name: "Chandrabose Senaisiva",
      jobTitle: "Senior Manager, Implementation & Support",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/bose.webp",
    },
    {
      name: "Kavitha G",
      jobTitle: "Senior Manager HR",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/kavitha.webp",
    },
    {
      name: "Sudha Avataram",
      jobTitle: "Marketing Director",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/sudha.webp",
    },
    {
      name: "Sultan Kasim",
      jobTitle: "Vice President Product Engineering",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/sultan.webp",
    },
    {
      name: "Sathish",
      jobTitle: "Chief Revenue Officer",
      avatar: "https://cdn.inextlabs.ai/images/company/teams/sathish.webp",
    },
  ],
  partners: {
    title: "Our Esteemed Partners and Recognitions",
    logos: [
      {
        id: "1",
        imageURL:
          "https://cdn.inextlabs.ai/images/company/aboutus/founders-hub.svg",
        alt: "Founders Hub",
      },
      {
        id: "2",
        imageURL:
          "https://cdn.inextlabs.ai/images/company/aboutus/Microsoft_SolutionsPartner_DataAIAzure.svg",
        alt: "Microsoft Solutions Partner",
      },
      {
        id: "3",
        imageURL: "https://cdn.inextlabs.ai/images/company/aboutus/md.svg",
        alt: "MD",
      },
      {
        id: "4",
        imageURL:
          "https://cdn.inextlabs.ai/images/company/aboutus/ai-verify.svg",
        alt: "AI Verify",
      },
      {
        id: "5",
        imageURL:
          "https://cdn.inextlabs.ai/images/company/aboutus/salesforce-logo.svg",
        alt: "Salesforce",
      },
    ],
  },
  coreValues: [
    {
      id: "1",
      title: "Customer Obsessed",
      imageURL: <UserRoundCheck />,
      descriptionOne: "Customer satisfaction is our #1 priority.",
      descriptionTwo:
        "We strive to ensure that we meet the requirements of our customer without any compromise on quality",
    },
    {
      id: "2",
      title: "Problem Solving",
      imageURL: <PuzzleIcon />,
      descriptionOne:
        "We are passionate about adding value and problem solving for our customers.",
      descriptionTwo:
        "We constantly thrive to explore new possibilities for our customers to accelerate and innovate their business​",
    },
    {
      id: "3",
      title: "Integrity and Trust",
      imageURL: <ShieldCheck />,
      descriptionOne: "Integrity and Trust are at the core of what we do.",
      descriptionTwo:
        "Complete transparency, mutual respect and trust with employees and clients are our key driving principles​",
    },
    {
      id: "4",
      title: "Innovation",
      imageURL: <Lightbulb />,
      descriptionOne: "We embrace innovation to drive growth and efficiency.",
      descriptionTwo:
        "We continuously seek out new technologies and methodologies to improve our products and services, ensuring we stay at the forefront of AI advancements.",
    },
  ],
  locations: [
    {
      id: "1",
      city: "Singapore",
      imageURL: "https://cdn.inextlabs.ai/images/company/obession.svg",
      address: "60 Paya Lebar Road #10-07 Paya Lebar Square Singapore 409051.",
    },
    {
      id: "2",
      city: "India",
      imageURL: "https://cdn.inextlabs.ai/images/company/solution.svg",
      address: `<strong>Chennai</strong> - HubFive Coworkz, No 104, Developed Plots, Origin Building, 2nd Floor, North Wing, Industrial Estate, Perungudi - 600096.`,
      addressTwo: `<strong>Coimbatore</strong> - 26, Vallalar Nagar, Next to Chinmaya school back gate, Vadavalli – 641041`,
    },
    {
      id: "3",
      city: "USA",
      imageURL: "https://cdn.inextlabs.ai/images/company/verified.svg",
      address: "1001 E Hebron Parkway Suite 118-291 Carrollton, TX 75010-1015",
    },
    {
      id: "3",
      city: "Malaysia",
      imageURL: "https://cdn.inextlabs.ai/images/company/verified.svg",
      address:
        "BLK E 02-2, Setiawalk, Persiaran Wawasan, Pusat Bandar Puchong, 47160 Puchong Selangor, Malaysia",
    },
  ],

  meta: {
    title: "Everything About Us",
    description:
      "Learn about iNextLabs, a leader in AI solutions. Discover our mission, team, and commitment to driving innovation across industries.",
    locale: "en_US",
    siteName: "iNextLabs",
    image: "https://www.inextlabs.com/images/general/resources.png",
    type: "website",
  },
};
